// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__gB7qr","type":"style__type__ZHlC-","label":"style__label__KtJJg"};